"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2465],{

/***/ 38579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63786);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"
}), 'ArrowForwardIos'));

/***/ }),

/***/ 88710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var _material_ui_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38579);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57833);
/* harmony import */ var shared_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41210);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  overflow: auto;\n  display: flex;\n  gap: ",
        "px;\n  margin: 0 auto;\n\n  ",
        " {\n    /* Hide scrollbar for Chrome, Safari and Opera */\n    ::-webkit-scrollbar {\n      display: none;\n    }\n\n    /* Hide scrollbar for IE, Edge and Firefox */\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 50px;\n  height: 50px;\n  background-color: white;\n  border-color: white;\n  transform: ",
        ";\n\n  ",
        " {\n    width: 55px;\n    height: 55px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      top: ",
        "px;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      left: ",
        "px;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      right: ",
        "px;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      bottom: ",
        "px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      top: 0;\n      bottom: 0;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  display: none;\n  z-index: 11;\n  right: ",
        ";\n  left: ",
        ";\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n  \n  display: flex;\n  align-items: center;\n\n  ",
        " {\n    display: block;\n    padding: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n\n  ",
        " {\n    display: block;\n    width: 88px;\n    height: 100%;\n    right: ",
        ";\n    left: ",
        ";\n    top: 0;\n    position: absolute;\n    pointer-events: none;\n    bottom: 0;\n    z-index: 10;\n    background: linear-gradient(\n      270deg,\n      #ffffff 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n\n    transform: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}






var DEFAULT_SCROLL_AMOUNT_IN_PIXEL = 300;
var FullWidthSlider = function(_param) {
    var children = _param.children, _scrollAmount = _param.scrollAmount, scrollAmount = _scrollAmount === void 0 ? DEFAULT_SCROLL_AMOUNT_IN_PIXEL : _scrollAmount, scrollButtonOffset = _param.scrollButtonOffset, _gap = _param.gap, gap = _gap === void 0 ? 3 : _gap, wrapperBoxProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "children",
        "scrollAmount",
        "scrollButtonOffset",
        "gap"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isScrollable = ref1[0], setScrollable = ref1[1];
    var ref2 = (0,shared_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_4__/* .useWindowSize */ .i)(), windowWidth = ref2.width;
    var buttonTopOffset = scrollButtonOffset && "top" in scrollButtonOffset && scrollButtonOffset.top;
    var buttonBottomOffset = scrollButtonOffset && "bottom" in scrollButtonOffset && scrollButtonOffset.bottom;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref1, ref2, ref3;
        var isCurrentlyScrollable = (ref === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.scrollHeight) ? ((ref2 = ref.current) === null || ref2 === void 0 ? void 0 : ref2.scrollWidth) > ((ref3 = ref.current) === null || ref3 === void 0 ? void 0 : ref3.clientWidth) : true;
        setScrollable(isCurrentlyScrollable);
    }, [
        windowWidth
    ]);
    var createScrollHandler = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(direction) {
        return function() {
            var element = ref.current;
            if (!element) {
                return;
            }
            var scrollLeft = element.scrollLeft;
            element.scrollTo({
                left: direction === "left" ? scrollLeft - scrollAmount : scrollLeft + scrollAmount,
                behavior: "smooth"
            });
        };
    }, [
        scrollAmount
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
        position: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WhiteFade, {
                position: "left"
            }),
            isScrollable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollButtonWrapper, {
                bottom: buttonBottomOffset || 0,
                top: buttonTopOffset || 0,
                position: "left",
                left: 0,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollButton, {
                    direction: "left",
                    onClick: createScrollHandler("left")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollableSection, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                justifyContent: isScrollable ? "start" : "center",
                px: 2,
                gap: gap,
                ref: ref
            }, wrapperBoxProps), {
                children: children
            })),
            isScrollable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollButtonWrapper, {
                bottom: buttonBottomOffset || 0,
                top: buttonTopOffset || 0,
                right: 0,
                position: "right",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollButton, {
                    direction: "right",
                    onClick: createScrollHandler("right")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WhiteFade, {
                position: "right"
            })
        ]
    });
};
var ScrollableSection = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box)(_templateObject(), function(param) {
    var gap = param.gap;
    return gap ? gap * 8 : 0;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var ScrollButton = function(param) {
    var onClick = param.onClick, direction = param.direction;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CircularButton, {
        flip: direction === "left",
        variant: "tertiary",
        rounded: true,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
    });
};
var CircularButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Button)(_templateObject1(), function(param) {
    var flip = param.flip;
    return flip && "rotate(-180deg)";
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
});
var ScrollButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div(_templateObject7(), function(param) {
    var position = param.position;
    return position === "right" ? "-80px" : "none";
}, function(param) {
    var position = param.position;
    return position === "left" ? "-80px" : "none";
}, function(param) {
    var top = param.top;
    return top && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject2(), top);
}, function(param) {
    var left = param.left;
    return (left !== null || left !== undefined) && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject3(), left);
}, function(param) {
    var right = param.right;
    return (right !== null || right !== undefined) && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject4(), right);
}, function(param) {
    var bottom = param.bottom;
    return bottom && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject5(), bottom);
}, function(param) {
    var top = param.top, bottom = param.bottom;
    return !bottom && !top && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject6());
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0, 4);
});
var WhiteFade = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var position = param.position;
    return position === "right" ? "-60px" : "none";
}, function(param) {
    var position = param.position;
    return position === "left" ? "-60px" : "none";
}, function(param) {
    var position = param.position;
    return position === "left" ? "rotate(-180deg)" : "none";
});
/* harmony default export */ __webpack_exports__["Z"] = (FullWidthSlider);


/***/ }),

/***/ 41210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useWindowSize = function() {
    var delay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 20;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)( true ? {
        width: window.innerWidth,
        height: window.innerHeight
    } : 0), windowSize = ref[0], setWindowSize = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var resizeTimeout;
        var handleResize = function() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function() {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            }, delay);
        };
        window.addEventListener("resize", handleResize);
        return function() {
            clearTimeout(resizeTimeout);
            window.removeEventListener("resize", handleResize);
        };
    }, [
        delay
    ]);
    return windowSize;
};


/***/ }),

/***/ 59593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26793);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 158%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #76a334;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: inherit;\n  color: inherit;\n  width: ",
        "px;\n\n  img {\n    width: 100%;\n    display: block;\n    position: relative;\n    transition: transform 0.5s ease, filter 0.5s ease;\n  }\n\n  &:hover img {\n    filter: brightness(0.9);\n    transform: scale(1.1);\n  }\n\n  &:hover .card-title {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n  position: relative;\n  width: 280px;\n  height: 210px;\n  border-radius: ",
        "px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: ",
        "px;\n  right: ",
        "px;\n  padding: ",
        ";\n  height: 28px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #f5f5f5;\n  border-radius: ",
        "px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var CARD_WIDTH = 280;
function ImageCard(param) {
    var href = param.href, ctaHighlight = param.ctaHighlight, cta = param.cta, imageSrc = param.imageSrc, pillText = param.pillText, _ctaTextAlign = param.ctaTextAlign, ctaTextAlign = _ctaTextAlign === void 0 ? "center" : _ctaTextAlign;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)("dynamic_landing_page").t;
    var WrapperComponent = href ? (next_link__WEBPACK_IMPORTED_MODULE_5___default()) : react__WEBPACK_IMPORTED_MODULE_2__.Fragment;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WrapperComponent, {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledLink, {
            target: "_blank",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
                    position: "relative",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImageWrapper, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                alt: "",
                                src: imageSrc,
                                objectFit: "cover",
                                width: CARD_WIDTH,
                                height: 210
                            })
                        }),
                        pillText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPill, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Typography, {
                                lineHeight: 1,
                                variant: "caption",
                                textAlign: true,
                                children: pillText
                            })
                        })
                    ]
                }),
                cta ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
                    pt: 1.5,
                    textAlign: ctaTextAlign,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TypographyCTA, {
                            component: "span",
                            className: "card-title",
                            children: cta ? cta : t("CTA")
                        }),
                        ctaHighlight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TypographyCompany, {
                            className: "card-title",
                            component: "span",
                            children: [
                                " ",
                                ctaHighlight
                            ]
                        })
                    ]
                }) : null
            ]
        })
    });
}
var TypographyCTA = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Typography)(_templateObject());
var TypographyCompany = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(TypographyCTA)(_templateObject1());
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].a(_templateObject2(), CARD_WIDTH);
var ImageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div(_templateObject3(), function(props) {
    return props.theme.spacing(1.5);
});
var StyledPill = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box)(_templateObject4(), function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(0.5, 1);
}, function(props) {
    return props.theme.spacing(8);
});
/* harmony default export */ __webpack_exports__["Z"] = (ImageCard);


/***/ }),

/***/ 92465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ RightCatering; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/lps/breakfast.jpeg
/* harmony default export */ var breakfast = ({"src":"/_next/static/media/breakfast.ccd54fab.jpeg","height":533,"width":800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAeEAAABgMBAQAAAAAAAAAAAAAAAQIDBRIEETETUf/EABUBAQEAAAAAAAAAAAAAAAAAAAEC/8QAGhEAAgMBAQAAAAAAAAAAAAAAAQIABBEDIf/aAAwDAQACEQMRAD8AuqCjIaOyXWsb2faQ3R147auquyLmy7z4AAJrEtz1vTGwAr4s/9k=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/lps/buffet.jpeg
/* harmony default export */ var buffet = ({"src":"/_next/static/media/buffet.af39ac2f.jpeg","height":533,"width":800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAfEAABAwQDAQAAAAAAAAAAAAABAAMRAgQFEwYSMWH/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/EABcRAQEBAQAAAAAAAAAAAAAAAAEAESH/2gAMAwEAAhEDEQA/AJsLyivIZB03Vt3abAq1bTBExBke/URFOBKD1v/Z","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/lps/christmas.jpeg
/* harmony default export */ var christmas = ({"src":"/_next/static/media/christmas.709c2c7b.jpeg","height":534,"width":800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAeEAABBAEFAAAAAAAAAAAAAAABAAIDBCEFETKBof/EABQBAQAAAAAAAAAAAAAAAAAAAAP/xAAYEQEAAwEAAAAAAAAAAAAAAAABAAIxEf/aAAwDAQACEQMRAD8AlsXtQmjbJNdfK7YlpeOJxkdD1ERDwdjFkyf/2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/lps/cocktails.jpeg
/* harmony default export */ var cocktails = ({"src":"/_next/static/media/cocktails.5b6dfeb4.jpeg","height":532,"width":800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAeEAACAQMFAAAAAAAAAAAAAAABAgADBTEREiEi8P/EABQBAQAAAAAAAAAAAAAAAAAAAAP/xAAYEQEAAwEAAAAAAAAAAAAAAAABAAIhEf/aAAwDAQACEQMRAD8Atcbs9uol6Suw7FQ9TcRzpkj2IiIdNGJd45P/2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/lps/coffee.jpeg
/* harmony default export */ var coffee = ({"src":"/_next/static/media/coffee.87b3b8c4.jpeg","height":533,"width":800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAdEAABBAIDAAAAAAAAAAAAAAABAAIEEQMFEoHR/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/xAAYEQADAQEAAAAAAAAAAAAAAAAAAQIRIf/aAAwDAQACEQMRAD8Aijb44bIOLJrY0gSSxh5AihddmifERElLC0+n/9k=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/lps/events.jpeg
/* harmony default export */ var events = ({"src":"/_next/static/media/events.514d7d19.jpeg","height":576,"width":800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAL/xAAdEAACAgIDAQAAAAAAAAAAAAABAgADETEEBSJx/8QAFAEBAAAAAAAAAAAAAAAAAAAAA//EABgRAQADAQAAAAAAAAAAAAAAAAEAAhED/9oADAMBAAIRAxEAPwCuxI5XfV8YKlNlrBketB4VkBO94GhjGfsREOlR3Y3WyOE//9k=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/lps/fingerfood.jpeg
/* harmony default export */ var fingerfood = ({"src":"/_next/static/media/fingerfood.8c0651f6.jpeg","height":533,"width":800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAhEAABAgQHAAAAAAAAAAAAAAABAAIDBBEyBQYTIUFRkf/EABQBAQAAAAAAAAAAAAAAAAAAAAX/xAAaEQABBQEAAAAAAAAAAAAAAAABAAIDERIi/9oADAMBAAIRAxEAPwCey5GlcRlG6kjCaG2MFjTUVNOT1v6iIjZzl9BJQ9Nsr//Z","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/lps/foodtruck.jpeg
/* harmony default export */ var foodtruck = ({"src":"/_next/static/media/foodtruck.6c5adccf.jpeg","height":572,"width":800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAdEAABBAIDAAAAAAAAAAAAAAABAAIDEQQFEiGh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQT/xAAXEQEBAQEAAAAAAAAAAAAAAAABAAIR/9oADAMBAAIRAxEAPwCPrchm4lnmEEcOSxzwx9cgKAu7Pd34iIpzJKvb/9k=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/lps/grill.jpeg
/* harmony default export */ var grill = ({"src":"/_next/static/media/grill.37b59b24.jpeg","height":533,"width":800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAeEAABAwQDAAAAAAAAAAAAAAABAAIDBBESE0FRkf/EABUBAQEAAAAAAAAAAAAAAAAAAAQF/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAECIf/aAAwDAQACEQMRAD8Arg1VcxzZIBm0MBkJ13uDbzntERFjSgpR/9k=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/lps/summerparty.jpeg
/* harmony default export */ var summerparty = ({"src":"/_next/static/media/summerparty.611b8325.jpeg","height":533,"width":800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAdEAABBQADAQAAAAAAAAAAAAABAAIDBBEFBhMx/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQL/xAAXEQEBAQEAAAAAAAAAAAAAAAABAAIh/9oADAMBAAIRAxEAPwCDd7by9iGf1tynGk4HloJ3PgxERADXrjf/2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/lps/vegan.jpeg
/* harmony default export */ var vegan = ({"src":"/_next/static/media/vegan.147fb4eb.jpeg","height":534,"width":800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAfEAACAgIBBQAAAAAAAAAAAAABAgADBBEFISIjMVH/xAAUAQEAAAAAAAAAAAAAAAAAAAAE/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQACMf/aAAwDAQACEQMRAD8AnczMtflBXcQ9lrnzL2sFO1K/DsL71vrERB60nJIDf//Z","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./src/shared/components/FullWidthSlider.tsx
var FullWidthSlider = __webpack_require__(88710);
// EXTERNAL MODULE: ./src/static_pages/components/ImageCard.tsx
var ImageCard = __webpack_require__(59593);
;// CONCATENATED MODULE: ./src/static_pages/home/variationB/components/RightCatering.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  overflow: hidden;\n  ",
        " {\n    padding: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  line-height: 34.5px;\n  font-weight: 700;\n  text-align: left;\n  ",
        " {\n    font-size: 36px;\n    line-height: 62.1px;\n    text-align: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  line-height: 23.52px;\n  font-weight: 400;\n  margin-top: ",
        "px;\n  text-align: center;\n  ",
        " {\n    font-size: 16px;\n    line-height: 26.88px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 47px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


















function RightCatering() {
    var t = (0,useTranslation/* useTranslation */.$)("homepage").t;
    var items = [
        {
            key: "fingerfood",
            href: "https://www.heycater.com/de/fingerfood",
            cta: t("rightCatering.cards.fingerfood"),
            pillText: "",
            imageSrc: fingerfood,
            ctaTextAlign: "left"
        },
        {
            key: "fruehstueck",
            href: "https://www.heycater.com/de/fruehstueck",
            cta: t("rightCatering.cards.breakfast"),
            pillText: "",
            imageSrc: breakfast,
            ctaTextAlign: "left"
        },
        {
            key: "food-truck",
            href: "https://www.heycater.com/de/food-truck",
            cta: t("rightCatering.cards.foodtruck"),
            pillText: "",
            imageSrc: foodtruck,
            ctaTextAlign: "left"
        },
        {
            key: "event",
            href: "https://www.heycater.com/de/event",
            cta: t("rightCatering.cards.events"),
            pillText: "",
            imageSrc: events,
            ctaTextAlign: "left"
        },
        {
            key: "buffet",
            href: "https://www.heycater.com/de/buffet",
            cta: t("rightCatering.cards.buffet"),
            pillText: "",
            imageSrc: buffet,
            ctaTextAlign: "left"
        },
        {
            key: "cocktail",
            href: "https://www.heycater.com/de/bar-cocktail",
            cta: t("rightCatering.cards.cocktail"),
            pillText: "",
            imageSrc: cocktails,
            ctaTextAlign: "left"
        },
        {
            key: "kaffeebar",
            href: "https://www.heycater.com/de/mobile-kaffeebar",
            cta: t("rightCatering.cards.coffee"),
            pillText: "",
            imageSrc: coffee,
            ctaTextAlign: "left"
        },
        {
            key: "vegan",
            href: "https://www.heycater.com/de/vegan",
            cta: t("rightCatering.cards.vegan"),
            pillText: "",
            imageSrc: vegan,
            ctaTextAlign: "left"
        },
        {
            key: "grill",
            href: "https://www.heycater.com/de/grill-catering",
            cta: t("rightCatering.cards.grill"),
            pillText: "",
            imageSrc: grill,
            ctaTextAlign: "left"
        },
        {
            key: "sommerfest",
            href: "https://www.heycater.com/de/sommerfest",
            cta: t("rightCatering.cards.summerparty"),
            pillText: "",
            imageSrc: summerparty,
            ctaTextAlign: "left"
        },
        {
            key: "firmenfeier",
            href: "https://www.heycater.com/de/catering-firmenfeier",
            cta: t("rightCatering.cards.christmas"),
            pillText: "",
            imageSrc: christmas,
            ctaTextAlign: "left"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: t("rightCatering.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                children: t("rightCatering.subtitle")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                my: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSlider/* default */.Z, {
                    scrollButtonOffset: {
                        top: 80
                    },
                    children: items.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageCard/* default */.Z, {
                            href: item.href,
                            cta: item.cta,
                            pillText: item.pillText,
                            imageSrc: item.imageSrc,
                            ctaTextAlign: item.ctaTextAlign
                        }, item.key);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                display: "flex",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "#qf-start",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        variant: "primary",
                        children: t("rightCatering.cta")
                    })
                })
            })
        ]
    });
}
var Wrapper = styled_components_browser_esm["default"].div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(0, 2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var Title = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var Subtitle = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var StyledButton = (0,styled_components_browser_esm["default"])(esm.Button)(_templateObject3());


/***/ })

}]);